import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@material-ui/core';
import { LoadingButton } from '~/modules/common/components';

export const ProjectCostOverridesActionComponent = ({
  onCancel,
  onSave,
  saveable = true,
  isSaving = false,
  validateForm,
  actionComponentCustomProps
}) => {
  const readOnly = actionComponentCustomProps?.readOnly ?? false;

  const handleSave = useCallback(async () => {
    if (validateForm) {
      const errors = await validateForm();

      if (Object.keys(errors).length) return;
    }
    onSave();
  }, [onSave, validateForm]);

  if (readOnly) {
    return (
      <Button onClick={onCancel} data-qe-id="ProjectCostOverridesClose">
        <FormattedMessage id="button.close" />
      </Button>
    );
  }

  return (
    <>
      <Button
        onClick={onCancel}
        disabled={isSaving}
        data-qe-id="ProjectCostOverridesCancel"
      >
        <FormattedMessage id="button.cancel" />
      </Button>
      <LoadingButton
        color="primary"
        onClick={handleSave}
        disabled={!saveable || isSaving}
        isLoading={isSaving}
        data-qe-id="ProjectCostOverridesSave"
      >
        <FormattedMessage id="button.save" />
      </LoadingButton>
    </>
  );
};

ProjectCostOverridesActionComponent.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saveable: PropTypes.bool,
  isSaving: PropTypes.bool,
  validateForm: PropTypes.func,
  actionComponentCustomProps: PropTypes.object
};

export default ProjectCostOverridesActionComponent;
